/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The hollow centre distinguishes it from a pie chart.`)
};

const es_donut_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El centro hueco lo distingue de un gráfico circular.`)
};

const de_donut_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die hohle Mitte unterscheidet es von einem Kreisdiagramm.`)
};

const nl_donut_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het holle midden onderscheidt het van een cirkeldiagram.`)
};

const fr_donut_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le centre creux le distingue d'un diagramme circulaire.`)
};

const it_donut_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il centro cavo lo distingue da un grafico a torta.`)
};

const pt_br2_donut_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O centro vazio o distingue de um gráfico de pizza.`)
};

const pt_donut_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O centro oco distingue-o de um gráfico circular.`)
};

const ja_donut_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央が空いている点が円グラフとの違いです。`)
};

const zh_donut_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中空的圆心使其区别于饼图。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_ex2", locale)
	if (locale === "en") return en_donut_ex2(inputs)
	if (locale === "es") return es_donut_ex2(inputs)
	if (locale === "de") return de_donut_ex2(inputs)
	if (locale === "nl") return nl_donut_ex2(inputs)
	if (locale === "fr") return fr_donut_ex2(inputs)
	if (locale === "it") return it_donut_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_donut_ex2(inputs)
	if (locale === "pt") return pt_donut_ex2(inputs)
	if (locale === "ja") return ja_donut_ex2(inputs)
	return zh_donut_ex2(inputs)
};